import { Colors, Services, getServiceNameViaPoint, isEmpty, regExp } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import { validationInfoStates } from '@/components/validationInfo'

import render from './render'

const serviceNameViaPoint = getServiceNameViaPoint(Services['url-shortener'])

const expireUrlMaxLength = 255

export default {
  name: 'ExpireFields',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    isExpireAfterHrsFilled() {
      return !isEmpty(this.proxy.expireAfterHrs)
    },
    isDeleteAfterExpireDaysFilled() {
      return !isEmpty(this.proxy.deleteAfterExpireDays)
    },
    isExpireUrlFilled() {
      return !isEmpty(this.proxy.expireUrl?.trim())
    },
    isExpireUrlFormatValid() {
      const expireUrl = this.proxy.expireUrl?.trim()
      if (isEmpty(expireUrl)) {
        return true
      }

      return regExp.validUrlStrict.test(expireUrl)
    },
    isExpireUrlLengthValid() {
      const expireUrl = this.proxy.expireUrl?.trim()

      return isEmpty(expireUrl) || expireUrl.length <= expireUrlMaxLength
    },
    isExpireUrlValid() {
      return this.isExpireUrlFormatValid && this.isExpireUrlLengthValid
    },

    validationGroups() {
      return [
        {
          rules: [
            {
              text: this.getTranslate(`${serviceNameViaPoint}.labels.expireAfterHrs`),
              state: this.getFilledState(this.isExpireAfterHrsFilled)
            },
            {
              text: this.getTranslate(`${serviceNameViaPoint}.labels.deleteAfterExpireDays`),
              state: this.getFilledState(this.isDeleteAfterExpireDaysFilled)
            },
            {
              text: this.getTranslate(`${serviceNameViaPoint}.hints.expire.validation.format`),
              state: this.getExpireUrlRuleState(this.isExpireUrlFormatValid)
            },
            {
              text: this.getTranslate(`${serviceNameViaPoint}.hints.expire.validation.length`),
              state: this.getExpireUrlRuleState(this.isExpireUrlLengthValid)
            }
          ]
        }
      ]
    },

    $_color() {
      switch (true) {
        case !this.isExpireUrlValid: return Colors.error
        case this.isExpireAfterHrsFilled:
        case this.isDeleteAfterExpireDaysFilled:
        case this.isExpireUrlFilled && this.isExpireUrlValid: return Colors.success
        default: return Colors.grey
      }
    }
  },

  watch: {
    isExpireUrlValid(value) {
      this.$emit('validation', value)
    }
  },

  mounted() {
    this.$emit('validation', this.isExpireUrlValid)
  },

  methods: {
    getFilledState(filled) {
      if (filled) {
        return validationInfoStates.valid
      }

      return validationInfoStates.empty
    },
    getExpireUrlRuleState(valid) {
      if (!this.isExpireUrlFilled) {
        return validationInfoStates.empty
      }
      if (valid) {
        return validationInfoStates.valid
      }

      return validationInfoStates.invalid
    },

    nullableNumber(value) {
      if (isEmpty(value)) {
        return null
      }

      return Number(value)
    },
    nullableString(value) {
      const trimmedValue = value?.trim()
      if (isEmpty(trimmedValue)) {
        return null
      }

      return trimmedValue
    }
  },

  render
}
